import React from "react";
import wp1 from "../assets/terms.jpg"; // same background image as Privacy Policy

const TermsAndConditions: React.FC = () => {
  const sections = [
    {
      title: "1. Acceptance of Terms",
      content: (
        <p className="text-gray-700">
          By using our website and services, you agree to comply with these terms and conditions. If you do not agree, please refrain from using our services.
        </p>
      ),
    },
    {
      title: "2. Services Overview",
      content: (
        <p className="text-gray-700">
          Luxuriya Homes provides interior design and waterproofing services. All descriptions, images, and specifications are for illustrative purposes only.
        </p>
      ),
    },
    {
      title: "3. User Responsibilities",
      content: (
        <ul className="list-disc list-inside space-y-2 text-gray-700">
          <li>Provide accurate and complete information during registration or inquiries.</li>
          <li>Follow instructions provided by our team for safe and efficient service delivery.</li>
          <li>Respect intellectual property rights of Luxuriya Homes and other users.</li>
        </ul>
      ),
    },
    {
      title: "4. Payment & Refunds",
      content: (
        <p className="text-gray-700">
          All payments must be made as per the agreed quotation. Refunds are processed only as described in the refund policy or upon service cancellation under defined circumstances.
        </p>
      ),
    },
    {
      title: "5. Limitation of Liability",
      content: (
        <p className="text-gray-700">
          Luxuriya Homes is not liable for indirect, incidental, or consequential damages arising from the use of our services, except where prohibited by law.
        </p>
      ),
    },
    {
      title: "6. Modifications",
      content: (
        <p className="text-gray-700">
          We reserve the right to modify these terms at any time. Updated terms will be posted on this page. Continued use of services constitutes acceptance of the revised terms.
        </p>
      ),
    },
    {
      title: "7. Contact Us",
      content: (
        <p className="text-gray-700">
          For any questions about these terms, reach out to us:
          <br />
          <span className="font-medium text-amber-500 mt-1 block">
            Email: hello@luxuriyahomes.com<br />
            Phone: +91 7291832000
          </span>
        </p>
      ),
    },
  ];

  return (
    <div className="bg-gray-50 min-h-screen text-gray-800">

      {/* ================= HERO ================= */}
      <section
        className="relative h-[55vh] flex items-center justify-center text-center bg-cover bg-center"
        style={{ backgroundImage: `url(${wp1})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/20"></div>
        <div className="relative z-10 max-w-3xl px-6">
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-amber-400 mb-4 drop-shadow-lg">
            Terms & Conditions
          </h1>
          <p className="text-gray-100 text-base md:text-lg drop-shadow">
            Please read these terms carefully before using our services.
          </p>
        </div>
      </section>

      {/* ================= CONTENT ================= */}
      <section className="max-w-5xl mx-auto px-6 py-20 space-y-16 font-sans">
        {sections.map((section, idx) => (
          <div
            key={idx}
            className="relative bg-white rounded-[2rem] p-12 shadow-2xl hover:shadow-3xl transition-shadow duration-500"
          >
            {/* Elegant accent line */}
            <div className="absolute -top-6 left-0 w-20 h-1 bg-gradient-to-r from-amber-400 to-amber-200 rounded-full"></div>
            
            <h2 className="text-3xl font-bold text-gray-800 mb-6">{section.title}</h2>
            <div className="text-gray-700 text-lg leading-relaxed">{section.content}</div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default TermsAndConditions;
